import * as React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';

import { ScheduleBoardContext } from '@acceligentllc/shared/enums/scheduleBoardContext';
import { ScheduleBoardProperty } from '@acceligentllc/shared/enums/scheduleBoardProperty';

import { bemBlock } from 'af-utils/bem.util';
import * as ScheduleBoardUtil from 'af-utils/scheduleBoard.util';

interface Props {
	dueDate: string;
	label: string;
	uniqueCode: string;
	isPlaceholder: boolean;
}

const ResourcePlaceholder: React.FC<Props> = (props) => {
	const { dueDate, label, uniqueCode, isPlaceholder } = props;

	const renderDraggable = React.useCallback((provided) => {
		return (
			<div
				ref={provided.innerRef}
				{...provided.draggableProps}
				{...provided.dragHandleProps}
				className={bemBlock('sb-resource-item', { placeholder: isPlaceholder })}
			>
				<div className="sb-resource-item__content">
					<span className="sb-resource-item__full-name sb-resource-item__full-name--transparent-bg">{label}</span>
				</div>
			</div>
		);
	}, [isPlaceholder, label]);

	return (
		<div className="resource-placeholder">
			<Droppable
				droppableId={ScheduleBoardUtil.generateDroppableId(ScheduleBoardContext.TOOLBAR, ScheduleBoardProperty.RESOURCE, dueDate, uniqueCode)}
				isDropDisabled={true}
			>
				{(droppableProvided) => {
					return (
						<div ref={droppableProvided.innerRef}>
							<Draggable
								draggableId={`${ScheduleBoardContext.TOOLBAR}#${ScheduleBoardProperty.RESOURCE}#${dueDate}#${uniqueCode}`}
								index={0}
							>
								{renderDraggable}
							</Draggable>
						</div>
					);
				}}
			</Droppable>
		</div>
	);
};

export default React.memo(ResourcePlaceholder);
